/**
 * PDP analytics — MVP-D (spec § 4.3 product_view anchor).
 *
 * Loaded globally via theme.liquid. Fires exactly ONE `product_view`
 * event per page load, guarded to product pages only. This is the
 * critical join anchor for the search → PDP session-attribution
 * reports: search_events rows with event_type = 'dropdown_query' /
 * 'dropdown_product_click' / 'search_product_click' get linked to
 * the PDP arrival via aro_session_id + product_handle.
 *
 * PDP detection:
 *   - theme.settings.product_id is set by the theme.liquid inline
 *     script (falsy on non-PDPs, real numeric id on PDPs)
 *   - URL matches /products/<handle> as a secondary sanity check
 *     (guards against admin views and edge cases)
 *
 * Retry poll for window.AroSearchAPI matches the pattern used by
 * aro-search-page-analytics.js (spec § 4.2 firePageView) — defer
 * script order between native-search-api.js and this file is not
 * reliably ordered in every browser.
 */
(function () {
  'use strict';

  function api() {
    return (window.AroSearchAPI && typeof window.AroSearchAPI.trackAroSearchEvent === 'function')
      ? window.AroSearchAPI
      : null;
  }

  function firePDPView() {
    // Guard: only fire on real PDPs
    var productId = (window.theme && window.theme.settings && window.theme.settings.product_id) || null;
    if (!productId) return;
    var match = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return;

    var handle = match[1];
    var a = api();
    if (!a) return;
    try {
      a.trackAroSearchEvent('product_view', {
        product_handle: handle,
        product_id: productId,
        referrer: document.referrer || null
      });
    } catch (e) { /* silent — analytics never blocks UX */ }
  }

  function whenApiReady(cb) {
    if (api()) return cb();
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (api()) { clearInterval(iv); cb(); }
      else if (tries > 60) { clearInterval(iv); } // ~3s cap, silent give-up
    }, 50);
  }

  function init() { whenApiReady(firePDPView); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
